<div class="card card-width border-0 m-0">
  <dx-load-panel #loadPanel [(visible)]="loadingVisible" [showIndicator]="true" [showPane]="true" [shading]="true"
    [closeOnOutsideClick]="false">
  </dx-load-panel>
  <div class="card-header header-stick" id="header">
    <div [ngClass]="{'float-left': !rtl , 'float-right': rtl}" class="my-auto">
      <h4 class="card-title">{{ meta?.caption }}
        <span class="badge badge-pill badge-warning" *ngIf="!loading && data">{{data?.length}}</span>
      </h4>
    </div>
    <div [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
      <ng-template [ngTemplateOutlet]="buttons"></ng-template>
    </div>
  </div>
  <div class="card-body p-2">
    <ngb-alert type="warning" [dismissible]="false" *ngFor="let warn of warnings">
      {{warn}}
    </ngb-alert>
    <ng-template *ngIf="view === 'GRID' && columns.length" [ngTemplateOutlet]="GRID"></ng-template>
    <ng-template *ngIf="view === 'CARD'" [ngTemplateOutlet]="CARD"></ng-template>
    <ng-template *ngIf="view === 'TREE'" [ngTemplateOutlet]="TREE"></ng-template>
    <ng-template *ngIf="view === 'PIVOT'" [ngTemplateOutlet]="PIVOT"></ng-template>
    <ng-template *ngIf="view === 'MAP'" [ngTemplateOutlet]="MAP"></ng-template>
    <ng-template *ngIf="view === 'TABLE'" [ngTemplateOutlet]="TABLE"></ng-template>
    <ng-template *ngIf="view === 'GRAPH'" [ngTemplateOutlet]="GRAPH"></ng-template>
  </div>
</div>

<ng-template #loadOptions let-holder='holder'>
  <div class="btn-group" ngbDropdown role="group">

    <div *ngIf="data?.length >= limit || !limit" class="btn-group" ngbDropdown role="group">
      <button class="btn btn-warning" ngbDropdownToggle data-toggle=" tooltip" title="{{ 'PAGE_SIZE' | translate }}">
        <i *ngIf="!limit" class="fa fa-asterisk"></i>
        {{ limit }}
      </button>

      <div class="dropdown-menu dropright" ngbDropdownMenu>
        <a *ngIf="unlimitedable" class="dropdown-item" (click)="changeLimit(null, holder);">{{'UNLIMITED' |
          translate}}</a>
        <a class="dropdown-item" (click)="changeLimit(10, holder);">10</a>
        <a class="dropdown-item" (click)="changeLimit(20, holder);">20</a>
        <a class="dropdown-item" (click)="changeLimit(50, holder);">50</a>
        <a class="dropdown-item" (click)="changeLimit(100, holder);">100</a>
        <a class="dropdown-item" (click)="changeLimit(200, holder);">200</a>
        <a class="dropdown-item" (click)="changeLimit(500, holder);">500</a>
        <a class="dropdown-item" (click)="changeLimit(1000, holder);">1000</a>
        <ng-container *ngIf="unlimitedable">
          <a class="dropdown-item" (click)="changeLimit(2000, holder);">2000</a>
          <a class="dropdown-item" (click)="changeLimit(5000, holder);">5000</a>
          <a class="dropdown-item" (click)="changeLimit(10000, holder);">10000</a>
          <a class="dropdown-item" (click)="changeLimit(20000, holder);">20000</a>
          <a class="dropdown-item" (click)="changeLimit(50000, holder);">50000</a>
        </ng-container>
      </div>
    </div>

    <div *ngIf="sortable" class="btn-group" ngbDropdown role="group">
      <button class="btn btn-warning" data-toggle="tooltip"
        title="{{ (desc ? 'DESCENDING' : 'ASCENDING') | translate }}" (click)="changeSortDb(orderby,!desc, holder)">
        <i class="fa" [ngClass]="{'fa-sort-amount-asc': !desc,'fa-sort-amount-desc':desc}"></i>
      </button>
      <button class="btn btn-warning" data-toggle="tooltip" title="{{ 'ORDER_BY' | translate }}" ngbDropdownToggle>
        <i class="fa fa-sort"></i>
        {{orderby.caption}}
      </button>
      <div class="dropdown-menu dropright" ngbDropdownMenu>
        <a *ngFor="let col of columns" class="dropdown-item"
          (click)="changeSortDb(col,desc, holder)">{{col.caption}}</a>
      </div>
    </div>

  </div>

</ng-template>

<ng-template #buttons>
  <div [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
    <input class="w-10" type="text" placeholder="{{'FILTER'|translate}}" [hidden]="!searchInput"
      (keyup)="filterData($event);">
    <button *ngIf="searchable && (view === 'CARD' || view === 'MAP')" class="btn btn-primary ml-1 mr-1"
      [ngClass]="{'active':filterValue.length}" (click)="this.searchInput = !this.searchInput;" aria-pressed="true">
      <i class="fa fa-lg fa-filter"></i>
    </button>

    <div *ngIf="secondaries.length || trivials.length" class="btn-group" role="group">
      <div class="btn-group" ngbDropdown role="group" *ngIf="trivials.length">
        <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
        <div class="dropdown-menu dropright" ngbDropdownMenu>
          <button *ngFor="let action of trivials" class="dropdown-item" ngbDropdownItem
            (click)="prepare(action,selectedRows)" data-toggle="tooltip" data-html="true" data-placement="bottom"
            title="{{action.tooltip || action.caption || action.name}}">
            <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
            {{ action.caption || action.name }}
            <span *ngIf="selectedRows[0] && selectedRows[0][action['name'].toLowerCase()]"
              class="badge badge-pill badge-warning">{{selectedRows[0][action['name'].toLowerCase()]}}</span>
          </button>
        </div>
      </div>

      <button *ngFor="let action of secondaries" class="btn {{action.class || 'btn-primary'}}"
        (click)="prepare(action,selectedRows)" data-toggle="tooltip"
        title="{{action.tooltip || action.caption || action.name}}">
        <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
        {{ !action.icon ? action.caption || action.name : '' }}
        <span *ngIf="selectedRows[0] && selectedRows[0][action['name'].toLowerCase()]"
          class="badge badge-pill badge-warning">{{selectedRows[0][action['name'].toLowerCase()]}}</span>
      </button>
    </div>


    <button *ngFor="let action of customActions" class="btn mx-1 {{action.class || 'btn-primary'}}"
      data-toggle="tooltip" title="{{action.tooltip || action.caption || action.name}}" (click)="perform(action,{})">
      <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
      {{ !action.icon ? (action.caption || action.name) : ''}}
    </button>

    <button *ngFor="let action of primaries" class="btn mx-1 {{action.class || 'btn-primary'}}"
      (click)="prepare(action,selectedRows)" data-toggle="tooltip"
      title="{{action.tooltip || action.caption || action.name}}">
      <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
      {{ !action.icon ? action.caption || action.name : '' }}
      {{selectedRows[0][action['name'].toLowerCase()] ? '(' + selectedRows[0][action['name'].toLowerCase()] + ')' : ''
      }}
    </button>

    <button *ngIf="importAllowed" class="btn btn-primary" data-toggle="tooltip" title="{{ 'IMPORT' | translate}}"
      (click)="import()">
      <i class="fa fa-lg fa-download"></i>
    </button>

    <button *ngIf="form && createAllowed" class="btn btn-success" data-toggle="tooltip"
      title="{{ 'CREATE' | translate}}" (click)="create()">
      <i class="fa fa-lg fa-plus"></i>
    </button>

    <div class="btn-group" role="group">
      <button class="btn btn-info" data-toggle="tooltip" title="{{ 'NEXT_PAGE' | translate }}" (click)="next()"
        *ngIf="data && data.length === limit">
        <i class="fa fa-lg fa-forward"></i>
      </button>
      <button class="btn btn-info" data-toggle="tooltip" title="{{ 'PREV_PAGE' | translate}} " (click)="previous()"
        *ngIf="skip && skip !== 0">
        <i class="fa fa-lg fa-backward"></i>
      </button>

      <button type="button" class="btn btn-info" data-toggle="tooltip" title="{{ 'REFRESH' | translate }}"
        (click)="load()">
        <i class="fa fa-lg fa-refresh" [ngClass]="{'fa-spin': loading}"></i>
      </button>
      <div class="btn-group" ngbDropdown role="group" *ngIf="autorefreshable && !isMobile">
        <button class="btn btn-info" data-toggle="tooltip" title="{{ 'AUTO_REFRESH' | translate }}" ngbDropdownToggle>
          <i class="fa fa-lg fa-bolt"></i>
          {{(refreshTime ? (refreshTime | secondsToTime:lang) : '')}}
        </button>
        <div class="dropdown-menu dropright" ngbDropdownMenu>
          <a class="dropdown-item" (click)="autoRefresh(0)">{{'AUTO_REFRESH_OFF' | translate}}</a>
          <a class="dropdown-item" (click)="autoRefresh(60)">{{(60 | secondsToTime:lang)}}</a>
          <a class="dropdown-item" (click)="autoRefresh(300)">{{(300 | secondsToTime:lang)}}</a>
          <a class="dropdown-item" (click)="autoRefresh(900)">{{(900 | secondsToTime:lang)}}</a>
          <a class="dropdown-item" (click)="autoRefresh(1800)">{{(1800 | secondsToTime:lang)}}</a>
          <a class="dropdown-item" (click)="autoRefresh(3600)">{{(3600 | secondsToTime:lang)}}</a>
        </div>
      </div>
    </div>

    <ng-template *ngIf="!isMobile" [ngTemplateOutlet]="loadOptions" [ngTemplateOutletContext]="{holder:'list'}">
    </ng-template>

    <div class="btn-group" role="group" *ngIf="searchable">
      <div *ngIf="filters?.length" class="btn-group" ngbDropdown role="group">
        <button class="btn btn-warning" ngbDropdownToggle data-toggle="tooltip"
          title="{{ 'SAVED_SEARCHS' | translate }}">
        </button>
        <div class="dropdown-menu dropright" ngbDropdownMenu *ngIf="filters?.length">
          <a class="dropdown-item" *ngFor="let f of filters" (click)="changeFilter(f);">{{f.name}}</a>
        </div>
      </div>

      <div *ngIf="filter?.id && filter?.created_by === username && !isMobile" class="btn-group" role="group">
        <button class="btn btn-warning" data-toggle="tooltip" title="{{ 'EDIT_SEARCH' | translate }}"
          (click)="open(searchAdvanced)">
          <i class="fa fa-lg fa-gear"></i>
        </button>
      </div>

      <div *ngIf="filter?.query" class="btn-group" role="group">
        <button class="btn btn-warning" data-toggle="tooltip" title="{{ 'CLEAR_SEARCH' | translate }}"
          (click)="clearFilter()">
          <i class="fa fa-lg fa-eraser"></i>
        </button>
      </div>

      <div class="btn-group" role="group">
        <button *ngIf="searchable" class="btn btn-warning" data-toggle="tooltip" title="{{ 'SEARCH' | translate }}"
          (click)="newFilter();open(search)">
          <i class="fa fa-lg fa-search"></i>
        </button>
      </div>

      <div *ngIf="!isMobile" class="btn-group" role="group">
        <button *ngIf="searchable" class="btn btn-warning" data-toggle="tooltip"
          title="{{ 'ADVANCED_SEARCH' | translate }}" (click)="newFilter();open(searchAdvanced)">
          <i class="fa fa-lg fa-binoculars"></i>
        </button>
      </div>
    </div>

    <div *ngIf="!isMobile && views.length > 1" class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic"
      [(ngModel)]="view" (ngModelChange)="viewChanged(view);">
      <label ngbButtonLabel class="btn-secondary" *ngFor="let mode of views">
        <input ngbButton type="radio" [value]="mode" data-toggle="tooltip" title="{{ mode | translate }}">
        <i class="fa fa-lg"
          [ngClass]="{'fa-map-o':mode === 'MAP','fa-bar-chart':mode === 'GRAPH','fa-sitemap':mode === 'TREE','fa-bars': mode =='GRID','fa-th-large':mode === 'CARD','fa-list-alt':mode === 'TABLE','fa-calculator':mode === 'PIVOT'}"></i>
      </label>
    </div>

  </div>
</ng-template>

<ng-template #search let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">
      {{'SEARCH' | translate}}
    </h4>
  </div>
  <div class="modal-body">
    <dx-form id="form" #formVar [(formData)]="searchData" [rtlEnabled]="rtl" colCount="2">
      <ng-container *ngFor="let formItem of searchFields">
        <dxi-item *ngIf="formItem.dataType === 'string' && !formItem.format" [name]="formItem.dataField"
          [dataField]="formItem.dataField" [editorOptions]="{ showClearButton:true}" [colSpan]="formItem.colSpan || 1">
          <dxo-label text="{{formItem.caption}}">
          </dxo-label>
        </dxi-item>

        <dxi-item [name]="formItem.dataField+'_from'"
          *ngIf="formItem.dataType === 'string' && (formItem.format === 'date' || formItem.format === 'datetime')">
          <dp-date-picker dir="rtl" [(ngModel)]="searchData[formItem.dataField + '_from']"
            [mode]="(formItem.format === 'datetime' ? 'daytime' : (formItem.format === 'date' ? 'day' : 'time'))"
            placeholder="{{ 'CHOOSE' | translate}}" showTwentyFourHours="true" theme="dp-material">
          </dp-date-picker>
          <dxo-label text="{{formItem.caption}} {{'FROM' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item [name]="formItem.dataField+'_to'"
          *ngIf="formItem.dataType === 'string' && (formItem.format === 'date' || formItem.format === 'datetime')">
          <dp-date-picker dir="rtl" [(ngModel)]="searchData[formItem.dataField + '_to']"
            [mode]="(formItem.format === 'datetime' ? 'daytime' : (formItem.format === 'date' ? 'day' : 'time'))"
            placeholder="{{ 'CHOOSE' | translate}}" showTwentyFourHours="true" theme="dp-material">
          </dp-date-picker>
          <dxo-label text="{{'TO' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.dataType === 'string' && formItem.format === 'time'"
          [name]="formItem.dataField+'_from'" [dataField]="formItem.dataField+'_from'"
          [editorOptions]="{ showClearButton:true, mask: '00:00', useMaskedValue: true}" colSpan="1">
          <dxo-label text="{{formItem.caption}} {{'FROM' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.dataType === 'string' && formItem.format === 'time'" [name]="formItem.dataField+'_to'"
          [dataField]="formItem.dataField+'_to'"
          [editorOptions]="{ showClearButton:true, mask: '00:00', useMaskedValue: true}" colSpan="1">
          <dxo-label text="{{'TO' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.dataType === 'number'" [name]="formItem.dataField+'_from'"
          [dataField]="formItem.dataField+'_from'" editorType="dxNumberBox" [editorOptions]="{ showClearButton:true}"
          colSpan="1">
          <dxo-label text="{{formItem.caption}} {{'FROM' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.dataType === 'number'" [name]="formItem.dataField+'_to'"
          [dataField]="formItem.dataField+'_to'" editorType="dxNumberBox" [editorOptions]="{ showClearButton:true}"
          colSpan="1">
          <dxo-label text="{{'TO' | translate}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.lookup" [name]="formItem.dataField" [dataField]="formItem.dataField"
          editorType="dxSelectBox"
          [editorOptions]="{ dataSource: formItem.lookup.dataSource,showClearButton:true, searchEnabled:true}"
          [colSpan]="formItem.colSpan || 1">
          <dxo-label text="{{formItem.caption}}">
          </dxo-label>
        </dxi-item>

        <dxi-item *ngIf="formItem.type === 'select'" [name]="formItem.dataField" [dataField]="formItem.dataField"
          editorType="dxSelectBox"
          [editorOptions]="{ dataSource: formItem.options,showClearButton:true, searchEnabled:true, displayExpr: 'name', valueExpr: 'value'}"
          [colSpan]="formItem.colSpan || 1">
          <dxo-label text="{{formItem.caption}}">
          </dxo-label>
        </dxi-item>

      </ng-container>

    </dx-form>

  </div>
  <div class="modal-footer">
    <ng-template [ngTemplateOutlet]="loadOptions"></ng-template>
    <button class="btn btn-light" data-toggle="tooltip" title="{{ 'CANCEL' | translate }}"
      (click)="filter={ query: null };c('Cancel click')">
      <i class="fa fa-lg fa-close"></i>
    </button>
    <button class="btn btn-success" data-toggle="tooltip" title="{{ 'OK' | translate }}"
      (click)="saveFilter('simple');c('Save click')">
      <i class="fa fa-lg fa-check"></i>
    </button>
  </div>
</ng-template>

<ng-template #searchAdvanced let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 *ngIf="!filter?.query">{{'ADVANCED_SEARCH' | translate}}</h4>
    <dx-text-box *ngIf="filter?.query" placeholder="{{'TITLE' | translate}}" [rtlEnabled]="rtl" [(value)]="filter.name"
      (onValueChanged)="filterNameChanged($event)">
    </dx-text-box>
  </div>
  <div class="modal-body">
    <dx-filter-builder rtl="true" [(value)]="filter.query" [customOperations]="customOperations"
      [disabled]="filter?.created_by && filter?.created_by !== username" (onValueChanged)="updateQuery($event)">
      <dxi-field *ngFor="let item of filterFields" dataField="{{item.dataField}}" dataType="{{item.dataType}}"
        caption="{{item.caption.toUpperCase()|translate}}">
        <dxo-lookup *ngIf="item.lookup" [dataSource]="item.lookup.dataSource" showClearButton="true"></dxo-lookup>
        <dxo-lookup *ngIf="item.options" [dataSource]="item.options" valueExpr="value" displayExpr="name"
          showClearButton="true"></dxo-lookup>
      </dxi-field>
    </dx-filter-builder>

    <dx-tag-box *ngIf="(!filter?.id && filter?.name) || (filter?.id && filter?.created_by === username)"
      [dataSource]="allRoles" displayExpr="name" [(value)]="filter.roles" valueExpr="value" [searchEnabled]="true"
      [rtlEnabled]="rtl" [maxDisplayedTags]="7" (onValueChanged)="changeShareView()" [showSelectionControls]="true"
      placeholder="{{'SHARE_IT' | translate}}">
    </dx-tag-box>

  </div>
  <div class="modal-footer">
    <ng-template [ngTemplateOutlet]="loadOptions"></ng-template>
    <button *ngIf="filter?.id && filter?.created_by === username" class="btn text-white btn-danger mr-1"
      data-toggle="tooltip" title="{{ 'DELETE' | translate }}" (click)="deleteFilter();c('Delete click')">
      <i class="fa fa-lg fa-trash"></i>
    </button>
    <button class="btn btn-light" data-toggle="tooltip" title="{{ 'CANCEL' | translate }}"
      (click)="filter={ query: null };c('Cancel click')">
      <i class="fa fa-lg fa-close"></i>
    </button>
    <button class="btn btn-success" data-toggle="tooltip" title="{{ 'OK' | translate }}"
      (click)="saveFilter('advanced');c('Save click')">
      <i class="fa fa-lg fa-check"></i>
    </button>
  </div>
</ng-template>

<ng-template #GRID>
  <dx-data-grid id="gridContainer" [ngStyle]="{'height': gridHeight}" [class]="title"
    [dataSource]="{store: { data: data, type: 'array', key: pkey }}" (onSelectionChanged)="onSelectionChanged($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)" [activeStateEnabled]="true" [rtlEnabled]="rtl"
    [columnAutoWidth]="false" [cacheEnabled]="true" [columnResizingMode]="'widget'" [allowColumnResizing]="true"
    [allowColumnReordering]="true" [showColumnLines]="true" [showRowLines]="true" [showBorders]="true"
    [rowAlternationEnabled]="true" [twoWayBindingEnabled]="false" (onRowExpanding)="onRowExpanding($event)"
    (onRowCollapsing)="onRowCollapsing($event)" (onContentReady)="onContentReady($event)"
    (onRowClick)="onRowClick($event)" (onCellPrepared)="onCellPrepared($event)"
    (onContextMenuPreparing)="onContextMenuPreparing($event)"
    [masterDetail]="{ enabled: hasDetail, template: 'detail' }">

    <dxi-column *ngFor="let col of columns" [visible]="col.visible"
      [dataField]="(col.pipe === 'localize' ? col.name + '_' + lang :col.name)" [caption]="col.caption"
      [width]="col.width || 'auto'" [dataType]="(col.dataType && col.dataType !== 'text' ? col.dataType : 'string')"
      [format]="col.format" [allowSearch]="true" [cellTemplate]="col.template" [alignment]="col.alignment"
      [cssClass]="(col.alignment === 'left' ? 'leftToRight' : '')">
      <dxo-lookup *ngIf="col.lookup && !col.lookup.dynamic" [dataSource]="col.lookup.dataSource"
        [valueExpr]="col.lookup.valueExpr || 'value'" [displayExpr]="col.lookup.displayExpr || 'name'"
        [allowClearing]="col.lookup.allowClearing" [searchEnabled]="col.lookup.searchEnabled"
        [searchMode]="col.lookup.searchMode" [searchExpr]="col.lookup.searchExpr">
      </dxo-lookup>

      <dxo-format *ngIf="col.pipe === 'bytes'" [formatter]="formatBytes"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'number'" [formatter]="formatNumber"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'money'" [formatter]="formatMoney"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'timeLength'" [formatter]="formatSeconds"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'timeLengthMinute'" [formatter]="formatMinutes"></dxo-format>
    </dxi-column>
    <dxo-header-filter [visible]="true" [allowSearch]="true">
    </dxo-header-filter>
    <dxo-scrolling mode="virtual" rowRenderingMode="virtual" columnRenderingMode="standard"></dxo-scrolling>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-export [printingEnabled]="true" [enabled]="exportAllowed" [allowExportSelectedData]="true"
      [excelFilterEnabled]="true" [fileName]="meta.caption">
    </dxo-export>
    <dxo-sorting></dxo-sorting>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="{{entity}}{{subentity || ''}}_grid">
    </dxo-state-storing>
    <dxo-selection mode="multiple" showCheckBoxesMode="onLongTap"></dxo-selection>
    <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="autoExpandAll || false" [expandMode]="'RowClick'">
    </dxo-grouping>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-column-chooser [allowSearch]="true" [enabled]="true" [mode]="'select'" [width]="250" [height]="500">
    </dxo-column-chooser>
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-search-panel [visible]="true" [width]="250" [highlightSearchText]="true"></dxo-search-panel>
    <dxo-summary>
      <dxi-group-item [column]="pkey" summaryType="count" [customizeText]="numberFormat">
      </dxi-group-item>
      <dxi-total-item [column]="pkey" summaryType="count" [customizeText]="numberFormat">
      </dxi-total-item>

      <ng-container *ngFor="let g of groups">

        <ng-container *ngIf="!g.pipe">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="numberFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="numberFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'money'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="moneyFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="moneyFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'bytes'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="bytesFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="bytesFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'timeLength'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'timeLengthMinute'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthMinuteFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthMinuteFormat">
          </dxi-total-item>
        </ng-container>

      </ng-container>

    </dxo-summary>
    <div *dxTemplate="let d of 'translateTemplate'">
      <span *ngIf="d.value">{{ d.value.toUpperCase() | translate }}</span>
    </div>
    <div *dxTemplate="let d of 'translateByCommaTemplate'">
      <span *ngFor="let word of d.value?.split(',')" [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
        {{ word.toUpperCase() | translate }},</span>
    </div>
    <div *dxTemplate="let d of 'linkTemplate'">
      <a href="http://{{d.value}}" target="_blank">{{d.value}}</a>
    </div>
    <div *dxTemplate="let d of 'templateTemplate'">
      <span *ngFor="let word of d.value | keys" [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
        {{word.toUpperCase() | translate}}:{{d.value|keys:word}},
      </span>
    </div>
    <div *dxTemplate="let d of 'dateTemplate'">
      <span>{{ d.value | dateformater : 2 }}</span>
    </div>
    <div *dxTemplate="let d of 'datetimeTemplate'">
      <span>{{ d.value | dateformater }}</span>
    </div>

    <div *dxTemplate="let d of 'detail'">
      <dx-data-grid *ngIf="d && d.data && d.data.items" [id]="d.data.id" [dataSource]="d.data.items"
        [activeStateEnabled]="true" [rtlEnabled]="rtl" [columnAutoWidth]="true" [cacheEnabled]="true"
        [columnResizingMode]="'widget'" [allowColumnResizing]="true" [allowColumnReordering]="false"
        [showColumnLines]="true" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
        [twoWayBindingEnabled]="false" class="detail">
        <dxo-sorting></dxo-sorting>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxi-column *ngFor="let col of d.data.itemColumns" [dataField]="col.name"
          [dataType]="col.type && col.type.name || 'string'" caption="{{col.caption}}" [width]="col.width || '100px'"
          alignment="{{col.alignment}}" [cssClass]="(col.alignment === 'left' ? 'leftToRight' : '')">
          <dxo-lookup *ngIf="col.type && col.type.name === 'select'" [dataSource]="col.type.options" displayExpr="name"
            valueExpr="value" searchEnabled="false">
          </dxo-lookup>
        </dxi-column>
      </dx-data-grid>
    </div>
  </dx-data-grid>
</ng-template>

<ng-template #PIVOT>
  <dx-pivot-grid id="pivotContainer" [ngStyle]="{'height': gridHeight}" [class]="title"
    [dataSource]="{ store: { data: data, type: 'array' }, fields: meta.pivot }" [rtlEnabled]="rtl">
    <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
    <dxo-export [printingEnabled]="true" [enabled]="exportAllowed" [allowExportSelectedData]="true"
      [excelFilterEnabled]="true" [fileName]="meta.caption">
    </dxo-export>
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
  </dx-pivot-grid>
</ng-template>

<ng-template #TREE>
  <dx-tree-list [dataSource]="data" accesskey="id" keyExpr="id" parentIdExpr="parent_id"
    [ngStyle]="{'height': gridHeight}" (onSelectionChanged)="onSelectionChanged($event)"
    (onToolbarPreparing)="onTreeToolbarPreparing($event)" [expandedRowKeys]="[1, 2]" [selectedRowKeys]="[1, 29, 42]"
    [wordWrapEnabled]="false" [autoExpandAll]="autoExpandAll" [activeStateEnabled]="true" rtl="rtl"
    [columnAutoWidth]="true" [cacheEnabled]="true" [columnResizingMode]="'widget'" [allowColumnResizing]="true"
    [allowColumnReordering]="true" [showColumnLines]="true" [showRowLines]="true" [showBorders]="true"
    [rowAlternationEnabled]="true" [twoWayBindingEnabled]="false" [expandNodesOnFiltering]="true">

    <dxi-column *ngFor="let col of columns" [visible]="col.visible"
      [dataField]="(col.pipe === 'localize' ? col.name + '_' + lang :col.name)" [caption]="col.caption"
      [width]="col.width || 'auto'" [dataType]="(col.dataType && col.dataType !== 'text' ? col.dataType : 'string')"
      [format]="col.format" [allowSearch]="true" [cellTemplate]="col.template" [alignment]="col.alignment"
      [cssClass]="(col.alignment === 'left' ? 'leftToRight' : '')">
      <dxo-format *ngIf="col.pipe === 'bytes'" [formatter]="formatBytes"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'number'" [formatter]="formatNumber"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'money'" [formatter]="formatMoney"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'timeLength'" [formatter]="formatSeconds"></dxo-format>
      <dxo-format *ngIf="col.pipe === 'timeLengthMinute'" [formatter]="formatMinutes"></dxo-format>
    </dxi-column>

    <dxo-header-filter [visible]="true" [allowSearch]="true">
    </dxo-header-filter>
    <dxo-scrolling useNative="false" mode="virtual" showScrollbar="never"></dxo-scrolling>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-sorting></dxo-sorting>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="{{entity}}{{subentity || ''}}_tree">
    </dxo-state-storing>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="autoExpandAll || false" [expandMode]="'RowClick'">
    </dxo-grouping>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-column-chooser [allowSearch]="true" [enabled]="true" [mode]="'select'" [width]="250" [height]="500">
    </dxo-column-chooser>
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-search-panel [visible]="true" [width]="250" [highlightSearchText]="true"></dxo-search-panel>
    <dxo-summary>
      <dxi-group-item [column]="pkey" summaryType="count" [customizeText]="numberFormat">
      </dxi-group-item>
      <dxi-total-item [column]="pkey" summaryType="count" [customizeText]="numberFormat">
      </dxi-total-item>

      <ng-container *ngFor="let g of groups">

        <ng-container *ngIf="!g.pipe">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="numberFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="numberFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'money'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="moneyFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="moneyFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'bytes'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="bytesFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="bytesFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'timeLength'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthFormat">
          </dxi-total-item>
        </ng-container>

        <ng-container *ngIf="g.pipe === 'timeLengthMinute'">
          <dxi-group-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthMinuteFormat">
          </dxi-group-item>
          <dxi-total-item [column]="g.name" [summaryType]="g.grouping" [customizeText]="timeLengthMinuteFormat">
          </dxi-total-item>
        </ng-container>

      </ng-container>

    </dxo-summary>
    <div *dxTemplate="let d of 'translateTemplate'">
      <span *ngIf="d.value">{{ d.value.toUpperCase() | translate }}</span>
    </div>
    <div *dxTemplate="let d of 'translateByCommaTemplate'">
      <span *ngFor="let word of d.value?.split(',')" [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
        {{ word.toUpperCase() | translate }},</span>
    </div>
    <div *dxTemplate="let d of 'linkTemplate'">
      <a href="http://{{d.value}}" target="_blank">{{d.value}}</a>
    </div>
    <div *dxTemplate="let d of 'templateTemplate'">
      <span *ngFor="let word of d.value | keys" [ngClass]="{'float-left': rtl , 'float-right': !rtl}">
        {{word.toUpperCase() | translate}}:{{d.value|keys:word}},
      </span>
    </div>
    <div *dxTemplate="let d of 'dateTemplate'">
      <span>{{ d.value | dateformater : 2 }}</span>
    </div>
    <div *dxTemplate="let d of 'datetimeTemplate'">
      <span>{{ d.value | dateformater }}</span>
    </div>

  </dx-tree-list>
</ng-template>

<ng-template #CARD>
  <div class="row px-3">
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-1" *ngFor="let row of data">
      <ng-template [ngTemplateOutlet]="carditem" [ngTemplateOutletContext]="{row: row}">
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #carditem let-row="row">
  <div *ngIf="row" class="card h-100">
    <div class="card-header">
      <span class="card-key" role="button" tabindex="0" (click)="copyKey(row[pkey], $event)"
        (keydown.enter)="copyKey(row[pkey], $event)" (keydown.space)="copyKey(row[pkey], $event)"
        title="{{'COPY' | translate}}">
        {{row[pkey]}}<i class="fa fa-copy card-key-icon" aria-hidden="true"></i>
      </span>
      <div *ngIf="row.actions && (row.actions | filter:'primary' :undefined).length"
        [ngClass]="rtl ? 'float-left' : 'float-right'" class="btn-group ml-1" ngbDropdown role="group">
        <button class="btn mx-1 btn-outline-primary" ngbDropdownToggle>
          <i class="fa fa-lg fa-gear"></i>
        </button>
        <div class="dropdown-menu dropright scrollable-menu" ngbDropdownMenu>
          <button class="dropdown-item" *ngFor="let action of row.actions  | filter:'primary' :undefined"
            (click)="prepare(action, [row])" data-toggle="tooltip" data-html="true" data-placement="bottom"
            title="{{action.tooltip || action.caption}}">
            <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
            {{action.caption || action.name}}
            {{row[action['name'].toLowerCase()] ? '(' + row[action['name'].toLowerCase()] + ')' : '' }}
          </button>
        </div>
      </div>

      <button class="btn mx-1 {{(action.class ? action.class.replace('btn-', 'btn-outline-') : 'btn-outline-primary')}}"
        [ngClass]="(rtl ? 'float-left' : 'float-right')" *ngFor="let action of row.actions | filter:'primary' : true"
        (click)="prepare(action, [row])" data-toggle="tooltip" data-html="true" data-placement="bottom"
        title="{{action.tooltip || action.caption }}">
        <i *ngIf="action.icon" class="fa fa-lg" [ngClass]="action.icon"></i>
        {{(!action.icon ? action.caption : '')|translate}}
      </button>
    </div>
    <div class="card-body p-0">
      <table class="w-100">
        <tbody>
          <ng-container *ngFor="let col of columns | filter:'visible' : true ">
            <tr
              *ngIf="(row[col.name] || row[col.name + '_' + lang] || (row[col.name] === 0 && !col.hideZero)) && col.name !== pkey && col.pipe !== 'template'">
              <td class="px-2" nowrap *ngIf="col.dataType !== 'text'">
                <span class="text-primary"
                  *ngIf="col.name !== pkey && col.pipe !== 'template' && (row[col.name] || row[col.name] === 0 || row[col.name + '_' + lang])"
                  data-toggle="tooltip" data-html="true" data-placement="top" title="{{col.caption}}"
                  data-trigger="hover">{{(col.caption.length > 24 ? col.caption.substring(0,22) :
                  col.caption)}}<span *ngIf="col.caption.length>24">..</span>:</span>

              </td>

              <td *ngIf="col.dataType === 'text'" colspan="2" class="w-100 text">
                <span class="text-primary">{{col.caption}}:</span>
                <span class="copyable" (click)="copyValue($event)"
                  title="{{'COPY' | translate}}">{{cardDate(row[col.name])}}</span>
              </td>

              <td *ngIf="col.dataType === 'boolean'">
                <span>
                  <i class="fa fa-lg fa-check text-success" *ngIf="row[col.name] === 'true' || row[col.name]"></i>
                  <i class="fa fa-lg fa-remove text-danger" *ngIf="row[col.name] === 'false' || !row[col.name]"></i>
                </span>
              </td>

              <td *ngIf="col.dataType !== 'text' && col.dataType !== 'boolean'" class="w-100 value copyable"
                (click)="copyValue($event)" title="{{'COPY' | translate}}">
                <ng-container [ngSwitch]="col.pipe">

                  <span *ngSwitchCase="'money'">
                    {{row[col.name] | money}}
                  </span>

                  <span *ngSwitchCase="'bytes'">
                    {{ row[col.name] | bytes:2:'B':'en' }}
                  </span>
                  <span *ngSwitchCase="'localize'">
                    {{row[col.name + '_' + lang]}}
                  </span>

                  <span *ngSwitchCase="'date'">
                    {{row[col.name] | dateformater: 2}}
                  </span>

                  <span *ngSwitchCase="'time'">
                    {{row[col.name] | dateformater: 3}}
                  </span>

                  <span *ngSwitchCase="'datetime'">
                    {{row[col.name] | dateformater}}
                  </span>

                  <a *ngSwitchCase="'link'" href="http://{{row[col.name] }}" target="_blank">
                    {{row[col.name]}}
                  </a>

                  <span *ngSwitchCase="'timeLengthMinute'">
                    {{row[col.name] | minuteToTimeStructured }}
                  </span>

                  <span *ngSwitchCase="'timeLength'">
                    {{row[col.name] | secondToTimeStructured }}
                  </span>

                  <span *ngSwitchCase="'translate'">
                    {{ row[col.name].toUpperCase() | translate }}
                  </span>

                  <span *ngSwitchCase="'translateByComma'">
                    <span *ngFor="let word of row[col.name].split(',')">
                      {{ word.toUpperCase() | translate }},
                    </span>
                  </span>

                  <span *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <span *ngSwitchCase="'date'">
                        {{row[col.name] | dateformater: 2}}
                      </span>

                      <span *ngSwitchCase="'time'">
                        {{row[col.name] | dateformater: 3}}
                      </span>

                      <span *ngSwitchCase="'datetime'">
                        {{row[col.name] | dateformater}}
                      </span>

                      <span *ngSwitchDefault>
                        {{cardDate(row[col.name])}}
                      </span>
                    </ng-container>
                  </span>
                </ng-container>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="row.template">
            <tr *ngFor="let c of row.template">
              <td class="text-primary px-2" nowrap data-toggle="tooltip" data-html="true" data-placement="top"
                title="{{c.caption}}" data-trigger="hover">
                {{(c.caption).length>24?(c.caption).substring(0,22):(c.caption)}}<span
                  *ngIf="(c.caption).length>24">..</span>:</td>
              <td class="w-100 value" [class.copyable]="typeOf(c.value) !== 'boolean'"
                (click)="typeOf(c.value) !== 'boolean' && copyValue($event)" title="{{'COPY' | translate}}">
                <span *ngIf="typeOf(c.value) !== 'boolean' && c.caption !== amount">
                  {{cardDate(c.value)}}
                </span>
                <span *ngIf="typeOf(c.value) !== 'boolean' && c.caption === amount">
                  {{c.value | number}}
                </span>
                <span *ngIf="typeOf(c.value) === 'boolean'">
                  <i class="fa fa-lg fa-check text-success" *ngIf="c.value"></i>
                  <i class="fa fa-lg fa-remove text-danger" *ngIf="!c.value"></i>
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #PAGER>
  <div class="col-md-12 d-flex justify-content-center pb-3" *ngIf="data && data.length > 20" style="z-index: 0;">
    <div class="btn-group">
      <div class="btn-group" role="group" *ngIf="cardPage>2">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(1)" *ngIf="cardPage>2">1</button>
      </div>
      <div class="btn-group" role="group"
        *ngIf="cardPage==Math.ceil(data.length/cardPageSize) && cardPage-3>0 && Math.ceil(data.length/cardPageSize)>4">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage-3)">{{ cardPage-3 }}</button>
      </div>
      <div class="btn-group" role="group"
        *ngIf="cardPage>=Math.ceil(data.length/cardPageSize)-1 && cardPage-2>0 && !(Math.ceil(data.length/cardPageSize)<5 && cardPage ==3)">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage-2)">{{ cardPage-2 }}</button>
      </div>
      <div class="btn-group" role="group" *ngIf="cardPage-1 >0">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage-1)">{{ cardPage-1 }}</button>
      </div>
      <div class="btn-group" role="group">
        <button class="btn btn-lg btn-primary active focus text-white" (click)="cardPaginatin(cardPage)">{{
          cardPage
          }}
        </button>
      </div>
      <div class="btn-group" role="group" *ngIf="cardPage+1<Math.ceil(data.length/cardPageSize)">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage+1)">{{ cardPage+1 }}</button>
      </div>
      <div class="btn-group" role="group" *ngIf="cardPage <3 && cardPage+2<Math.ceil(data.length/cardPageSize)">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage+2)">{{ cardPage+2 }}</button>
      </div>
      <div class="btn-group" role="group" *ngIf="cardPage <2 && cardPage+3<Math.ceil(data.length/cardPageSize)">
        <button class="btn btn-lg btn-primary" (click)="cardPaginatin(cardPage+3)">{{ cardPage+3 }}</button>
      </div>
      <div class="btn-group" role="group" *ngIf="cardPage < Math.ceil(data.length/cardPageSize)">
        <button class="btn btn-lg btn-primary"
          (click)="cardPaginatin(Math.ceil(data.length/cardPageSize))">{{Math.ceil(data.length/cardPageSize)}}</button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #TABLE>
</ng-template>

<ng-template #GRAPH>
  <canvas *ngIf="graphData && graphData.length && graphLabel && graphLabel.length" baseChart [datasets]="graphData"
    [labels]="graphLabel" style="height:50vh;width:50vh;" [options]="graphOption" legend="true" [chartType]="chartType">
  </canvas>
</ng-template>

<ng-template #MAP>
  <div id="map" class="map" leaflet [leafletOptions]="mapOptions" [leafletLayers]="layers"
    [leafletLayersControl]="layersControl" (leafletMapReady)="onMapReady($event)" (click)="mapClick($event)">
  </div>
</ng-template>

<ng-template #info>
  <ng-template [ngTemplateOutlet]="carditem" [ngTemplateOutletContext]="{row: (selectedRows || [])[0]}">
  </ng-template>
</ng-template>